<div class="eligibility-lookup flex flex-column gap-3">
  <div class="flex flex-wrap align-items-end gap-3">
    <div class="flex flex-column gap-1">
      <label for="eligibility-source">Source</label>
      <p-dropdown
        inputId="eligibility-source"
        [options]="sources"
        [(ngModel)]="selectedSource"
        placeholder="Select source"
        styleClass="w-12rem">
      </p-dropdown>
    </div>

    <div class="flex flex-column gap-1">
      <label>Lookup by</label>
      <p-selectButton [options]="lookupModes" [(ngModel)]="lookupMode" optionLabel="label" optionValue="value"></p-selectButton>
    </div>

    <ng-container *ngIf="lookupMode === 'memberId'; else demographicsFields">
      <div class="flex flex-column gap-1">
        <label for="eligibility-member-id">Member ID</label>
        <input id="eligibility-member-id" pInputText [(ngModel)]="memberId" class="w-16rem" />
      </div>
    </ng-container>

    <ng-template #demographicsFields>
      <div class="flex flex-column gap-1">
        <label for="eligibility-first-name">First name</label>
        <input id="eligibility-first-name" pInputText [(ngModel)]="firstName" class="w-12rem" />
      </div>
      <div class="flex flex-column gap-1">
        <label for="eligibility-last-name">Last name</label>
        <input id="eligibility-last-name" pInputText [(ngModel)]="lastName" class="w-12rem" />
      </div>
      <div class="flex flex-column gap-1">
        <label for="eligibility-dob">Date of birth</label>
        <p-calendar inputId="eligibility-dob" [(ngModel)]="dateOfBirth" [showIcon]="true" dateFormat="mm/dd/yy"></p-calendar>
      </div>
    </ng-template>

    <p-button label="Lookup eligibility" icon="pi pi-search" [disabled]="!canLookup" (onClick)="lookup()"></p-button>
  </div>

  <div *ngIf="loading" class="flex align-items-center gap-2">
    <p-progressSpinner strokeWidth="4" styleClass="eligibility-spinner"></p-progressSpinner>
    <span>Checking eligibility…</span>
  </div>

  <p-message *ngIf="errorMessage" severity="error" [text]="errorMessage"></p-message>

  <div *ngIf="response && !loading" class="flex flex-column gap-3">
    <div class="flex flex-column gap-1">
      <div class="flex flex-wrap gap-3 align-items-center">
        <div *ngIf="subscriberLabel" class="font-semibold">{{ subscriberLabel }}</div>
        <p-tag *ngIf="planStatus" [value]="planStatus" severity="success"></p-tag>
        <p-tag
          *ngIf="showHdhpTag"
          [value]="hdhpAssessment?.label || 'HDHP'"
          [severity]="hdhpAssessment?.status === 'Named' ? 'info' : 'warning'"
          [title]="hdhpAssessment?.reason || ''">
        </p-tag>
        <span *ngIf="planName && planName !== planStatus" class="text-color-secondary">{{ planName }}</span>
      </div>
      <div *ngIf="showHdhpTag && hdhpAssessment?.reason" class="category-note">{{ hdhpAssessment?.reason }}</div>
    </div>

    <div *ngIf="accumulators.length" class="accumulator-grid">
      <div class="accumulator-card" *ngFor="let acc of accumulators">
        <div class="flex align-items-center gap-2">
          <div class="accumulator-label">{{ acc.type === 'OutOfPocket' ? 'Out of Pocket' : acc.type }}</div>
          <p-tag *ngIf="acc.met" value="Met" severity="success"></p-tag>
        </div>
        <div class="accumulator-meta">
          {{ acc.coverageLevel }} · {{ acc.network || 'Network n/a' }}
        </div>
        <div *ngIf="acc.remaining != null && acc.limit != null" class="accumulator-remaining">
          Remaining {{ acc.remaining | currency }} of {{ acc.limit | currency }}
        </div>
        <div *ngIf="acc.remaining != null && acc.limit == null" class="accumulator-remaining">
          Remaining {{ acc.remaining | currency }}
        </div>
        <div *ngIf="acc.remaining == null && acc.limit != null" class="accumulator-amount">
          Annual {{ acc.limit | currency }}
        </div>
        <div *ngIf="acc.spent != null" class="accumulator-amount">Spent {{ acc.spent | currency }}</div>
      </div>
    </div>

    <div *ngIf="serviceDesignGroups.length" class="flex flex-column gap-3">
      <div class="font-semibold">Service designs</div>
      <div *ngFor="let group of serviceDesignGroups" class="service-design-group flex flex-column gap-2">
        <div class="flex flex-column gap-1">
          <div class="font-semibold">{{ group.label }}</div>
          <div *ngIf="categoryNote(group.category)" class="category-note">{{ categoryNote(group.category) }}</div>
        </div>

        <p-table [value]="group.designs" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Service</th>
              <th>Network</th>
              <th>Deductible</th>
              <th>Copay</th>
              <th>Coinsurance</th>
              <th>Summary</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>
                <div>{{ row.serviceName }}</div>
                <div class="text-color-secondary text-sm">STC {{ row.serviceCode }}</div>
              </td>
              <td>{{ row.network }}</td>
              <td>{{ row.deductibleRule || '—' }}</td>
              <td>{{ row.copayAmount != null ? (row.copayAmount | currency) : '—' }}</td>
              <td>
                <ng-container *ngIf="row.coinsurancePercent != null">
                  {{ coinsuranceDisplay(row.coinsurancePercent)! | percent:'1.0-2' }}
                </ng-container>
                <ng-container *ngIf="row.coinsurancePercent == null">—</ng-container>
              </td>
              <td>
                <div>{{ row.summary }}</div>
                <div *ngIf="row.priorAuthRequired" class="text-sm">
                  <p-tag value="Prior auth" severity="warning"></p-tag>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <details *ngIf="response.raw">
      <summary>Raw eligibility response</summary>
      <pre class="raw-json">{{ response.raw | json }}</pre>
    </details>
  </div>
</div>
